<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="paddingContent">
      <div class="tableWrap">
        <el-table height='660px' stripe :data="postList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in postTable" :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width">
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count='5'
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
export default {
  data () {
    return {
      navBlock:'社區',
      navtitle:'帖子投訴 / 投訴詳情',
      listMenuForm:{
        postId: '',
        postTitle: '',
        startTime: '',
        endTime: '',
      },
      
      postList:[],
      postTable: [
        {
          prop: 'memberId',
          label: '用戶id',
          width: '140'
        }, {
          prop: 'content',
          label: '投訴詳情',
          width: ''
        }, {
          prop: 'createTime',
          label: '投訴時間',
          width: '150'
        },
      ],
      currentPage: 1, // 分页
      total: 0,
      dialogVisible: false,
      id: this.$route.query.id,
      type: this.$route.query.type,
    }
  },
  created(){
    this.getReasonList();
  },
  mounted(){
  },
  activated(){
    if (this.currentPage === 1){
      this.getReasonList();
    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取帖子列表信息
    getReasonList(){
      let _this = this;
      let param ={
        aboutComplaintId: _this.id,
        aboutComplaintType: _this.type,
        pageNo: _this.currentPage,
        pageSize: 10,
      }
      this.$post('/unity/complaintLists', param, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            res.data.list.forEach(v=>{
              v.createTime= this.$getTime(v.createTime)
            })
            _this.postList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            this.$propMessage(res.message, 'error');
          };
        });
    },
    // 分页
    handleCurrentChange (val) {
      this.currentPage = val;
      this.getPostList();
    },

  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
  .content{
    .paddingContent{
      .ListMenu{
        .MenuBtnWrap{
          display: flex;
          justify-content: flex-end;
          .btn:last-child{
            margin-left: 0.2rem;
          }
        }
      }
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
    .topBtn{
      width:50px;
    }
  }
  @media screen and (min-width: 769px) {
    .ListMenu{
        display: flex;
        justify-content: space-between;
        .searchForm{
          flex: 1;
          display: flex;
          justify-content: flex-start;
        }
        .MenuBtnWrap{
          flex: 1;
        }
      }
  }
</style>




// WEBPACK FOOTER //
// src/pages/community/complainReason.vue